import React from 'react';

import { isEqual, noop } from 'lodash';
import { shape, bool, func } from 'prop-types';
import { connect } from 'react-redux';

import withUserType from 'containers/withUserType';

import MobileSideNav from './MobileSideNav';
import DesktopSideNav from './DesktopSideNav/DesktopSideNav';

@withUserType
@connect(
  ({ user: { moduleAccess, userMode } }) => ({
    moduleAccess,
    userMode,
  }),
  null,
)
export default class SideNav extends React.Component {
  shouldComponentUpdate(nextProps, nextStates) {
    return !isEqual(nextProps, this.props) || !isEqual(nextStates, this.state);
  }

  render() {
    const {
      user,
      userMode,
      moduleAccess,
      isMobile,
      appbarOpen,
      toggleAppbar = () => null,
      push = () => null,
      responsive,
      ...restProps
    } = this.props;

    if (!moduleAccess) return null;
    if (isMobile && responsive)
      return (
        <MobileSideNav
          {...{
            push,
            appbarOpen,
            toggleAppbar,
            ...restProps,
          }}
        />
      );
    return <DesktopSideNav {...restProps} />;
  }
}

SideNav.propTypes = {
  moduleAccess: shape({}),
  user: shape({}),
  userMode: shape({}),
  isMobile: bool,
  appbarOpen: bool,
  toggleAppbar: func,
  push: func,
  responsive: bool,
};

SideNav.defaultProps = {
  moduleAccess: undefined,
  user: null,
  userMode: null,
  isMobile: false,
  appbarOpen: false,
  toggleAppbar: noop,
  push: noop,
  responsive: false,
};
